import { ReactNode } from 'react';
import { WorksheetField } from '../../../worksheets/common/components/Field';
import WorksheetForm from '~/features/projectWizard/worksheets/common/components/WorksheetForm';
import {
  LongTermOwnerDropdownOptions,
  PartnerTypeRadioOptions,
  EpcCompanyTypeDropdownValues,
  EpcCompanyType
} from '~/constants';
import { useDerivedProjectSetupFields } from '~/features/projectWizard/worksheets/common/derived/useDerivedProjectSetupFields';
import { useDerivedRECFields } from '~/features/projectWizard/derived';
import { useProjectContext } from '~/hooks';
import { useDerivedContractFields } from '~/features/projectWizard/worksheets/common/derived/useDerivedContractFields';

// Radio option arrays in the codebase use { value, label }, but semantic-ui-react
// dropdowns expect { value, text }.
const toDropdownOptions = <T extends { value: unknown; label: ReactNode }>(options: T[]) =>
  options.map(({ label, ...rest }) => ({ ...rest, text: label }));

export default function ProjectRoles() {
  const { projectDisplayValues } = useProjectContext();

  const epcCompanyOptions = EpcCompanyTypeDropdownValues.map(option =>
    option.value === EpcCompanyType.SELF && projectDisplayValues?.projectDetails?.developer ? {
      value: option.value,
      label: projectDisplayValues?.projectDetails?.developer
    } : option
  );

  // Update certain values automatically based on field changes
  useDerivedProjectSetupFields();
  useDerivedRECFields();
  useDerivedContractFields();

  return (
    <WorksheetForm>
      <WorksheetField
        type="dropdown"
        schemaKey="longTermOwner"
        fieldLabel="Who will own and operate the system once it's built?"
        placeholder="Select an owner"
        options={toDropdownOptions(LongTermOwnerDropdownOptions)}
      />
      <WorksheetField
        type="dropdown"
        schemaKey="epcCompanyType"
        fieldLabel="Who will install the system?"
        placeholder="Select an installer"
        options={toDropdownOptions(epcCompanyOptions)}
      />
      <WorksheetField
        type="text"
        schemaKey="epcCompanyName"
        fieldLabel="EPC name"
        placeholder="Enter EPC name"
      />
      <WorksheetField
        type="dropdown"
        schemaKey="partnerType"
        fieldLabel="What type of partner are you seeking?"
        placeholder="Select a partner type"
        options={toDropdownOptions(PartnerTypeRadioOptions)}
      />
    </WorksheetForm>
  );
}
